module.exports = __webpack_public_path__ + "img/clement-hoop.2a89ff40.png";